import React from "react";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const TradePaymentDbt: React.FunctionComponent<IProps> = (props) => {
    const showPreviousReport = props.bCreditReportData?.uiData?.previousDate ? true : false;

    return (
        <React.Fragment>
            <div className="link-item">
                {props.showAsAccordion ? (
                    <button
                        type="button"
                        aria-expanded="false"
                        className="link-button"
                        id="btn-days-beyond-term"
                        onClick={(e) => toggle("days-beyond-term-div", "btn-days-beyond-term")}
                    >
                        <span className="row link-item">
                            <span className="col-xs col-no-gutter link-text">
                                <span className="link-title">
                                    <span className="btn-toggle-status sr-only">Show</span> Days Beyond Term (DBT)
                                </span>
                            </span>
                        </span>
                    </button>
                ) : (
                    <h5 className="report-sub-title">Days Beyond Term (DBT)</h5>
                )}

                <div className="wallet-details" id="days-beyond-term-div" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }} aria-hidden="true">
                    <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-days-beyond-term">
                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="dbt-dbt"></div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" id="dbt-current">
                                    Current ({props.bCreditReportData?.uiData?.currentDate})
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                {showPreviousReport && (
                                    <div className="data-label" id="dbt-previous">
                                        Previous ({props.bCreditReportData?.uiData?.previousDate})
                                    </div>
                                )}
                            </div>
                        </div>

                        <div role="row" className="data-row condensed row">
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-label" aria-labelledby="dbt-dbt">
                                    Days Beyond Term (DBT)
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                <div className="data-value" aria-labelledby="dbt-current">
                                    {props.reportObject?.businessCompanyReport?.monthly_dbt_trends?.[0].days_beyond_terms
                                        ? props.reportObject?.businessCompanyReport?.monthly_dbt_trends?.[0].days_beyond_terms
                                        : "--"}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                {showPreviousReport && (
                                    <div className="data-value" aria-labelledby="dbt-previous">
                                        {props.reportObject?.businessCompanyReport?.previous_monthly_dbt_trends?.[0].days_beyond_terms
                                            ? props.reportObject?.businessCompanyReport?.previous_monthly_dbt_trends?.[0].days_beyond_terms
                                            : "--"}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TradePaymentDbt;
